// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2d6bb8e0] .v-list--nav .v-list-item:before {\n  border-radius: 9999px;\n}\n[data-v-2d6bb8e0] .v-navigation-drawer__border {\n  background-color: unset !important;\n}", ""]);
// Exports
module.exports = exports;
